import { Button } from 'antd'
import React from 'react'

function DisableButton({children}) {
  return (
    <Button disabled className='auf-button'>{children}</Button>
  )
}

export default DisableButton